import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { CampaignAddressesDisplayMode, SelectedAwarenessCampaignActions } from '../../../store/reducers/awareness_campaigns/selected';
import ToggleButtons from '../../_include/ToggleButtons';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import { Box } from '@mui/material';
import { Namespace } from '../../../locales/translations';

export default function CampaignAddressesDisplayToggle() {

    const { t } = useTranslation([Namespace.ADDRESSES]);

    const dispatch = useAppDispatch();

    const addressesDisplayMode = useAppSelector((state) => state.awareness_campaign.selected.addressesDisplayMode);

    const handleChange = (newAlignment: CampaignAddressesDisplayMode) => {
        dispatch(SelectedAwarenessCampaignActions.setAddressesDisplayMode(newAlignment));
    };

    const options = [
        {
            label: t('list_view', { ns: Namespace.ADDRESSES }),
            value: CampaignAddressesDisplayMode.LIST,
            Icon: <AssignmentRoundedIcon />,
        },
        {
            label: t('map_view', { ns: Namespace.ADDRESSES }),
            value: CampaignAddressesDisplayMode.MAP,
            Icon: <MapRoundedIcon />,
        },
    ];

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            <ToggleButtons
                color="secondary"
                value={addressesDisplayMode}
                exclusive
                fullWidth
                sx={{
                    maxWidth: theme => theme.spacing(40),
                }}
                onChange={(_, newAlignment) => handleChange(newAlignment)}
                options={options}
            />
        </Box>
    );
}